/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const es_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNds`)
};

const de_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const nl_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const fr_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNdb`)
};

const it_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const pt_br2_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const pt_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsADN`)
};

const ja_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA`)
};

const zh_dnamw_dsdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dsDNA（双链 DNA）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_dsdna = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_dsdna(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_dsdna", locale)
	if (locale === "en") return en_dnamw_dsdna(inputs)
	if (locale === "es") return es_dnamw_dsdna(inputs)
	if (locale === "de") return de_dnamw_dsdna(inputs)
	if (locale === "nl") return nl_dnamw_dsdna(inputs)
	if (locale === "fr") return fr_dnamw_dsdna(inputs)
	if (locale === "it") return it_dnamw_dsdna(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_dsdna(inputs)
	if (locale === "pt") return pt_dnamw_dsdna(inputs)
	if (locale === "ja") return ja_dnamw_dsdna(inputs)
	return zh_dnamw_dsdna(inputs)
};